export const UPDATE_CART_DATA = "UPDATE_CART_DATA";
